<template>
  <section class="sc-about">
    <div class="sc-about-inner">
      <h2 class="sc-about-title">
        About Our Summer Program
      </h2>

      <!-- Math + English Camp card -->
      <div class="sc-program-card">
        <!-- 深紫色 header 条 -->
        <div class="sc-program-header sc-program-header--purple">
          <div class="sc-program-header-pattern" />
          <div class="sc-program-header-content">
            <div><span class="header-text-white">Math + English Camp </span><span class="header-text-yellow">Half Day</span><span class="header-text-white"> Camp</span></div>
            <span class="header-grade">【Incoming Grade 1 - Incoming Grade 6】</span>
          </div>
        </div>
        <!-- 内容区 -->
        <div class="sc-program-body sc-program-body--purple">
          <div class="sc-program-photo-wrap">
            <img v-lazy-load :data-src="kidsPhoto" alt="Kids learning" class="sc-program-photo">
          </div>
          <div class="sc-program-info">
            <p class="sc-program-desc">
              A comprehensive summer learning experience with real-time <strong class="text-red">1-on-1</strong> support.
            </p>
            <div class="sc-program-tags">
              <div class="sc-tag-row">
                <span class="sc-tag sc-tag--red">Math</span>
                <span class="sc-tag-text">Personalized study plans tailored to each child's needs.</span>
              </div>
              <div class="sc-tag-row">
                <span class="sc-tag sc-tag--purple">English</span>
                <span class="sc-tag-text">Skill-based practice in spelling, vocabulary, and reading.</span>
              </div>
            </div>
            <p class="sc-program-sub">
              Personalized, fun, and effective—plus a free assessment to create a personalized learning plan.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import kidsPhoto from 'assets/web/images/summerCamp/about-kids-photo.png';

export default {
  name: 'SummerCampAboutProgram',
  data() {
    return {
      kidsPhoto,
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-about {
  padding-bottom: 50px;
  background: #fff;
  font-family: 'Roboto-Flex', sans-serif;

  .sc-about-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 50px;
  }

  .sc-about-title {
    font-size: 48px;
    font-weight: 600;
    line-height: 48px;
    color: #44454c;
    text-align: center;
    margin: 0;
    font-family: 'Roboto-Flex', sans-serif;
  }

  .sc-program-card {
    border-radius: 20px;
    overflow: hidden;
  }

  // header 条
  .sc-program-header {
    position: relative;
    height: 90px;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 0 45px;
    border-radius: 20px 20px 0 0;

    &--purple {
      background: #3d3e81;
    }

    .sc-program-header-pattern {
      position: absolute;
      inset: 0;
      background-image: url('~assets/web/images/summerCamp/program-bg.png');
      background-size: cover;
      background-position: center;
      transform-origin: center;
    }

    .sc-program-header-content {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      font-family: 'Roboto-Bold', sans-serif;
      font-size: 36px;
      font-weight: 700;
      line-height: 30px;
      color: #fff;

      .header-text-white {
        color: #fff;
      }
      .header-text-yellow {
        color: #ffd400;
      }

      .header-grade {
        font-size: 22px;
        font-weight: 900;
        color: #fff;
        white-space: nowrap;
      }
    }
  }

  // 内容体
  .sc-program-body {
    display: flex;
    border-radius: 0 0 20px 20px;

    &--purple {
      background: #efefff;
      min-height: 363px;
    }

    .sc-program-photo-wrap {
      width: 536px;
      flex-shrink: 0;
      overflow: hidden;
      border-radius: 0 0 0 20px;

      .sc-program-photo {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
      }
    }

    .sc-program-info {
      flex: 1;
      padding: 38px 24px 38px 32px;
      display: flex;
      flex-direction: column;
      gap: 0;

      .sc-program-desc {
        font-size: 24px;
        font-weight: 600;
        line-height: 40px;
        color: #44454c;
        margin: 0 0 0;
        text-transform: capitalize;

        .text-red {
          color: #e53131;
          font-weight: 900;
        }
      }

      .sc-program-sub {
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        color: #4a4a4a;
        margin: auto 0 0;
        text-transform: capitalize;
      }

      .sc-program-tags {
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        gap: 14px;

        .sc-tag-row {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 6px;
          padding: 0 5px;
          height: 48px;
          gap: 20px;

          .sc-tag {
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100px;
            height: 36px;
            padding: 0 12px;
            font-size: 24px;
            font-weight: 600;
            color: #fff;
            letter-spacing: 0.72px;

            &--red { background: #e53131; }
            &--purple { background: #3d3e81; }
          }

          .sc-tag-text {
            font-size: 18px;
            font-weight: 500;
            color: #45454c;
            letter-spacing: 0.54px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
